import React, { useEffect, useState } from 'react';
import { ENUM_BONUS_LABEL, ENUM_CUS_EVENT } from '../../../enums/enums';
import { dispatchCusEvent } from '../../../utils';
import { API_GROUP, API_USER } from '../../../api/user';
import useToast from '../../useToast';
import { useAppSelector } from '../../../store';

export default function useEditJackpot(groupId) {
  const jackTabs = ['mini', 'major', 'grand'];

  const defaultCurrency = {
    initial: 1,
    minBet: 1,
    minAmount: 1,
    maxAmount: 1,
    minDeposit: 1,
    depositDays: 1,
    amount: 1,
    forcedDrop: false
  };

  const defaultBonus = {
    rub: defaultCurrency,
    eur: defaultCurrency,
    uzs: defaultCurrency,
    usdt: defaultCurrency
  };

  const defaultJack = {
    betPercent: 0.5,
    Mini: defaultBonus,
    Major: defaultBonus,
    Grand: defaultBonus
  };
  const { successToast, errorToast } = useToast();
  const jackpot = useAppSelector((state) => state.user.jackpots?.[groupId]);

  const [activeTab, setActiveTab] = useState(1);
  const [bonusJacks, setBonusJacks] = useState(jackpot?.list);
  // const [updateSubgroups, setUpdateSubgroups] = useState(false);

  const jackName = jackTabs[activeTab];

  const currentBonus = bonusJacks?.[jackName];
  const rate = currentBonus?.betPercent;
  const superUser = jackpot?.superUser;
  const welcomeEnable = currentBonus?.enabled;
  // const lockSetting = bonusJacks?.updateLocked;

  useEffect(() => {
    setBonusJacks(jackpot?.list || defaultJack);
  }, [jackpot]);

  const onTabChange = (_, indx) => setActiveTab(indx);
  // const changeSubgroup = () => setUpdateSubgroups((prev) => !prev);
  // const changeLockSetting = () => setUpdateSubgroups((p) => ({ ...p, updateLocked: !lockSetting }));

  const changeRate = (val) => {
    if (val > 100) {
      errorToast('The number cannot be greater than 100');
      return;
    }
    setBonusJacks((prev) => {
      const newJack = JSON.parse(JSON.stringify(prev));
      newJack[jackName].betPercent = +Number(val).toFixed(2);
      return newJack;
    });
  };

  const changeEnable = () =>
    setBonusJacks((prev) => {
      const newJack = JSON.parse(JSON.stringify(prev));
      newJack[jackName].enabled = !newJack[jackName].enabled;
      return newJack;
    });

  const changeField = (currency, name, value) =>
    setBonusJacks((prev) => {
      const newJack = JSON.parse(JSON.stringify(prev));

      if (!newJack[jackName]) newJack[jackName] = {};
      if (!newJack[jackName].values[currency]) newJack[jackName].values = {};
      if (!newJack[jackName].values[currency]) newJack[jackName].values[currency] = {};

      newJack[jackName].values[currency][name] = value;

      return newJack;
    });

  const onSave = () => {
    API_GROUP.bonus.jackpots
      .update({ groupId: groupId, jackpots: bonusJacks })
      .then((e) => {
        dispatchCusEvent(ENUM_CUS_EVENT.getJackpotsList, { groupId });
        successToast('Information updated successfully');
      })
      .catch(console.log);
  };

  return {
    // lockSetting,
    // updateSubgroups,
    jackTabs,
    activeTab,
    welcomeEnable,
    rate,
    currentBonus,
    superUser,
    changeField,
    // changeSubgroup,
    // changeLockSetting,
    changeEnable,
    onTabChange,
    changeRate,
    onSave
  };
}
